import { ThemeContext, defaultThemeContext } from "../../../context/theme.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Theme = function Theme(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultThemeContext : _ref$theme,
    children = _ref.children;
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: theme,
    children: children
  });
};